

import { Vue, Component, Prop } from 'vue-property-decorator'
import BlockHeader from '~/components/shared/block-header.vue'
import AppLink from '~/components/shared/app-link.vue'
import { ICategory } from '~/interfaces/category'

type BlockCategoriesLayout = 'classic' | 'compact';

@Component({
    components: { BlockHeader, AppLink }
})
export default class BlockCategories extends Vue {
    @Prop({ type: String, required: true }) title!: string
    @Prop({ type: String, default: () => 'classic' }) layout!: BlockCategoriesLayout
    @Prop({ type: Array, default: () => [] }) categories!: ICategory[]
}

